// src/pages/NotFound/NotFoundPage.tsx
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import MainLayout from '../../components/MainLayout/MainLayout';

const NotFoundPage = () => {
  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-neutral-900 to-slate-950 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          {/* 404 Number */}
          <div className="mb-8">
            <h1 className="text-9xl logo-text font-display bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 bg-clip-text text-transparent text-glow-hover">
              404
            </h1>
          </div>
          
          {/* Error Message */}
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-white mb-4">
              Page Not Found
            </h2>
            <p className="text-gray-300 text-lg">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-700 hover:to-red-700 text-white px-6 py-3 rounded-full font-medium transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-orange-500/30"
            >
              <Home className="h-5 w-5 mr-2" />
              Go Home
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center border border-white/20 text-white hover:bg-white/10 px-6 py-3 rounded-full font-medium transition-all duration-200 hover:scale-105"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Go Back
            </button>
          </div>
          
          {/* Decorative Elements */}
          <div className="mt-12 opacity-50">
            <div className="text-6xl">🌌</div>
            <p className="text-gray-400 mt-2">Lost in the digital cosmos</p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NotFoundPage;
